import React, { Component, createRef } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

// Импорт стилей Swiper
import 'swiper/css'
import 'swiper/css/navigation'

class App extends Component {
  constructor(props) {
    super(props)
    this.swiperRef = createRef()
    this.state = {
      isBeginning: true,
      isEnd: false
    }
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    })
  }

  render() {
    const { data } = this.props
    const partners = data?.partners || {}
    const { isBeginning, isEnd } = this.state

    if (!partners || !partners.items) {
      return null
    }

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center'>
            <div className='flex gap-[10px] text-[14px] xl:text-[16px]'>
              <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5005 5.37C13.4555 5.3625 13.403 5.3625 13.358 5.37C12.323 5.3325 11.498 4.485 11.498 3.435C11.498 2.3625 12.3605 1.5 13.433 1.5C14.5055 1.5 15.368 2.37 15.368 3.435C15.3605 4.485 14.5355 5.3325 13.5005 5.37Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.7276 10.8301C13.7551 11.0026 14.8876 10.8226 15.6826 10.2901C16.7401 9.58512 16.7401 8.43012 15.6826 7.72512C14.8801 7.19262 13.7326 7.01262 12.7051 7.19262" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.47785 5.37C4.52285 5.3625 4.57535 5.3625 4.62035 5.37C5.65535 5.3325 6.48035 4.485 6.48035 3.435C6.48035 2.3625 5.61785 1.5 4.54535 1.5C3.47285 1.5 2.61035 2.37 2.61035 3.435C2.61785 4.485 3.44285 5.3325 4.47785 5.37Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.25008 10.8301C4.22258 11.0026 3.09008 10.8226 2.29508 10.2901C1.23758 9.58512 1.23758 8.43012 2.29508 7.72512C3.09758 7.19262 4.24508 7.01262 5.27258 7.19262" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.00055 10.9725C8.95555 10.965 8.90305 10.965 8.85805 10.9725C7.82305 10.935 6.99805 10.0875 6.99805 9.03754C6.99805 7.96504 7.86055 7.10254 8.93305 7.10254C10.0055 7.10254 10.868 7.97254 10.868 9.03754C10.8605 10.0875 10.0355 10.9425 9.00055 10.9725Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.81754 13.335C5.76004 14.04 5.76004 15.195 6.81754 15.9C8.01754 16.7025 9.98254 16.7025 11.1825 15.9C12.24 15.195 12.24 14.04 11.1825 13.335C9.99004 12.54 8.01754 12.54 6.81754 13.335Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60'>Наши партнеры</div>
              </div>
            </div>
          </div>
          
          <div className='flex items-end justify-between gap-[20px]'>
            <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(partners?.title)}</h2>
            
            {/* Кастомная навигация */}
            <div className='hidden xl:flex items-center gap-[5px]'>
              <div 
                className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                  isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                }`}
                onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
              >
                <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.75269 0.25L0.577271 5.75L3.75269 11.25" stroke="white"/>
                </svg>
              </div>
              <div 
                className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                  isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                }`}
                onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
              >
                <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white"/>
                </svg>
              </div>
            </div>
          </div>
          
          <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60 tracking-[-0.02em]'>{Parser(partners?.text)}</div>
          
          {/* Слайдер с логотипами партнеров */}
          <div className='mt-[20px] hidden xl:block'>
            <Swiper
              onSwiper={(swiper) => {
                this.swiperRef.current = swiper
                this.handleSlideChange(swiper)
              }}
              onSlideChange={this.handleSlideChange}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={5}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 10
                },
                480: {
                  slidesPerView: 3,
                  spaceBetween: 10
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 10
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 10
                }
              }}
              className='partners-slider'
            >
              {partners.items.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className='w-full h-[130px] rounded-[15px] bg-[#F5F7F9] flex items-center justify-center overflow-hidden'>
                    <img 
                      src={item.image} 
                      alt={item.alt || `Партнер ${index + 1}`} 
                      className='max-w-[162px] max-h-[101px] w-auto h-auto object-contain'
                      loading="lazy"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className='mt-[30px] xl:hidden w-[calc(100%+10px)] overflow-x-auto overflow-y-hidden flex items-center gap-[10px] pb-[10px]'>
            {partners.items.map((item, index) => (
              <div key={index} className='w-[228px] h-[130px] rounded-[15px] bg-[#F5F7F9] flex-none flex items-center justify-center overflow-hidden'>
                <img 
                  src={item.image} 
                  alt={item.alt || `Партнер ${index + 1}`} 
                  className='max-w-[162px] max-h-[101px] w-auto h-auto object-contain'
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default App